import { useState, useEffect } from 'react';

import './Dashboard.css';
import { FaPlus } from 'react-icons/fa';
import { UserUtils } from '../../utils/UserUtils';
import DashboardTable from '../../ui/panels/Tables/DashboardTable/DashboardTable';
import NewUserForm from '../../ui/panels/Forms/NewUserForm/NewUserForm';
import { useNavigate } from 'react-router-dom';
import SideColumnScaffold from '../../ui/pageScaffolds/SideColumnScaffold/SideColumnScaffold';
import SideBarContent from '../../ui/panels/SideBars/SideBarContent/SideBarContent';

interface Patient {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  status: 'Active' | 'In Progress';
  lawyerCount: number;
  physicianCount: number;
}

interface UserDetailObject {
  userName: string;
  id: string;
  email: string;
  role: string;
}

// TODO Dashboard Page follow pattern in the rest of the project
function Dashboard(): JSX.Element {
  const nav = useNavigate();
  const [patients, setPatients] = useState<Patient[]>([]);
  const [showNewUserForm, setShowNewUserForm] = useState<boolean>(false);
  const [token, setToken] = useState<string>(
    localStorage.getItem('token') || ''
  );

  const [userDetails, setUserDetails] = useState<UserDetailObject>({
    userName: '',
    id: '',
    email: '',
    role: '',
  });

  useEffect(() => {
    if (token) {
      getUserList();
    }

    if (token == '') {
      nav('/signin');
    }

    const userDetails = UserUtils.decodeUserToken(token);
    if (!userDetails) {
      nav('/signin');
    } else {
      setUserDetails(userDetails);
    }
  }, [token]);

  const getUserList = async () => {
    const url = '/admin/getPatientsListing/1'; //TODO: Hardcoding 1 now. Need to replace 1 with correct value for pagination for scaling
    try {
      const userList = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!userList.ok) {
        console.error(
          'Error while fetching user list response:',
          userList.statusText
        );
        return;
      }

      const userListData = await userList.json();
      setPatients(userListData.patients);
    } catch (error) {
      console.log('Error while fetching user list data');
      console.log(error);
    }
  };

  const handleOpenNewUserForm = () => {
    setShowNewUserForm(true);
  };

  const handleCloseNewUserForm = () => {
    setShowNewUserForm(false);
  };

  const handleNewUserCreated = () => {
    getUserList();
  };

  const handleOnLogout = () => {
    localStorage.removeItem('token');
    nav('/signin');
  };

  return (
    <SideColumnScaffold
      sideBarContent={
        <SideBarContent
          nav={nav}
          userRole={userDetails.role}
          currentPath={window.location.pathname}
          userName={userDetails.userName}
          onLogout={handleOnLogout}
        />
      }
      mainContent={
        <div className="dashboard-container">
          <div className="dashboard-head-row">
            <h2>Patients</h2>
            <button onClick={handleOpenNewUserForm}>
              <FaPlus className="dashboard-head-row-icon" />
              <span>Add New User</span>
            </button>
          </div>

          {/* User table UI */}
          <DashboardTable dashboardData={patients} />

          {showNewUserForm && (
            <NewUserForm
              token={token}
              nav={nav}
              handleCloseFormPressed={handleCloseNewUserForm}
              onUserCreated={handleNewUserCreated}
            />
          )}
        </div>
      }
    />
  );
}

export default Dashboard;
